import React,{useContext, useState, useRef,useMemo} from 'react';
import { DatabaseContext } from '../../redux/DatabaseStore';
import { useFormik } from 'formik';
import { getRequest, postRequest } from '../../api/ApiController';
import { SaveIcon, AddIcon, CopyIcon, VerticalLineIcon, FavoriteIcon, PriceIcon, SaveAndCloseIcon} from "../svg/svgIcons";
import AuthContext from '../../components/AuthContext';
import UtilContext from '../../components/UtilContext';
import { LocaleContext } from '../../components/LocaleContext';
import IntersectionObserverWrapper from '../../components/toolbar/IntersectionObserverWrap';
import { Checkbox } from "primereact/checkbox";
import { Select } from "antd";
import countryList from 'react-select-country-list';
import countries from "i18n-iso-countries";
import "i18n-iso-countries/langs/sk";
countries.registerLocale(require("i18n-iso-countries/langs/sk"));
countries.registerLocale(require("i18n-iso-countries/langs/en"));
countries.registerLocale(require("i18n-iso-countries/langs/de"));

export default function BusinessPartnerAdd({business_partner, type="add"}) {

    const [state,dispatch] = useContext(DatabaseContext);
    const {user} = useContext(AuthContext);
    const {openFavoriteDialog,toast,setFastView,setVisible,setDialogText}= useContext(UtilContext);
    const { t, locale } = useContext(LocaleContext);

    const [closeTab,setCloseTab] = useState(false);
    const submitRef = useRef(null);

    const [formBusinessPartner, setFormBusinessPartner] = useState(
        type === 'copy' && business_partner != null ? { ...business_partner, id: undefined } : business_partner,
    );
    const [formType, setFormType] = useState(type === 'copy' ? 'add' : type);
    const countryOptions = useMemo(() => {
        return countryList().getData().map(country => ({
            value: country.value,
            label: countries.getName(country.value, locale === 'de' ? 'de' : (locale === 'en' || locale === 'gb') ? 'en' : 'sk') || country.label
        }));
    }, [locale]);

    const [insertCopyIcon,setInsertCopyIcon] = useState(!user.permissions?.includes("edit settings"));
    const customerClientTypeOptions = useMemo(() => ([
        { value: 'new_client', label: t('BusinessPartnerAdd.Type.new_client') },
        { value: 'potential_client', label: t('BusinessPartnerAdd.Type.potential_client') },
        { value: 'verified_client', label: t('BusinessPartnerAdd.Type.verified_client') },
        { value: 'inquiring_client', label: t('BusinessPartnerAdd.Type.inquiring_client') },
        { value: 'occasional_customer', label: t('BusinessPartnerAdd.Type.occasional_customer') },
        { value: 'regular_customer', label: t('BusinessPartnerAdd.Type.regular_customer') },
        { value: 'strategic_customer', label: t('BusinessPartnerAdd.Type.strategic_customer') },
        { value: 'lost_customer', label: t('BusinessPartnerAdd.Type.lost_customer') },
    ]), [t]);
    const clientTypeValues = useMemo(() => new Set([
        'new_client',
        'potential_client',
        'verified_client',
        'inquiring_client',
    ]), []);
    const customerTypeValues = useMemo(() => new Set([
        'occasional_customer',
        'regular_customer',
        'strategic_customer',
        'lost_customer',
    ]), []);
    const clientTypeOptions = useMemo(
        () => customerClientTypeOptions.filter((opt) => clientTypeValues.has(opt.value)),
        [customerClientTypeOptions, clientTypeValues]
    );
    const customerTypeOptions = useMemo(
        () => customerClientTypeOptions.filter((opt) => customerTypeValues.has(opt.value)),
        [customerClientTypeOptions, customerTypeValues]
    );

    const resolvePartnerMode = (partner) => {
        const status = partner?.partner_status_by_type;
        if (status && typeof status === 'object' && status.party_mode) {
            return status.party_mode;
        }
        if (partner?.types?.includes('customer')) return 'customer';
        if (partner?.types?.includes('client')) return 'client';
        return 'client';
    };

    const traderName = useMemo(() => {
        return formBusinessPartner?.contractor?.employee?.name || formBusinessPartner?.contractor?.username || '-';
    }, [formBusinessPartner]);

    const customerState = useMemo(() => {
        if (formType === 'add') {
            return t('BusinessPartnerAdd.ReadOnly.CustomerState.Free');
        }
        return formBusinessPartner?.contractor_id
            ? t('BusinessPartnerAdd.ReadOnly.CustomerState.Occupied')
            : t('BusinessPartnerAdd.ReadOnly.CustomerState.Free');
    }, [formBusinessPartner, formType, t]);

    function addNewErrorType(){
      dispatch({type:'create_new_tab',name: t('BusinessPartnerList.Tab.New'), translationKey: 'BusinessPartnerList.Tab.New', legacyLabel: t('BusinessPartnerList.Tab.New'),page:'BusinessPartnerAdd',props:{business_partner: null,type:'add'},mask:'gset008'});
    }
    function copyErrorType(){
      dispatch({type:'create_new_tab',name: t('BusinessPartnerList.Tab.New'), translationKey: 'BusinessPartnerList.Tab.New', legacyLabel: t('BusinessPartnerList.Tab.New'),page:'BusinessPartnerAdd',props:{business_partner: null, type:'add'},mask:'gset008'});
    }

    const validate = values => {
        const errors = {};
        /*if (!values.type) {
            errors.type = t('Common.RequiredField');
        }*/
        return errors;
    };

    const formik = useFormik({
        initialValues: formBusinessPartner==null?{
            name: '',types: [],defined_id: '',address: '',tel_number: '',email: '',
            web_address: '',contact_person: '',description: '',country:'',
            partner_status_by_type: { party_mode: 'client', customer: '', client: '' }
        }:{
            id: formBusinessPartner?.id, name: formBusinessPartner?.name, types: formBusinessPartner?.types,defined_id: formBusinessPartner?.defined_id,
            address: formBusinessPartner?.address,tel_number: formBusinessPartner?.tel_number,email: formBusinessPartner?.email,
            web_address: formBusinessPartner?.web_address,contact_person: formBusinessPartner?.contact_person,description: formBusinessPartner?.description,
            country: formBusinessPartner?.country ? formBusinessPartner?.country : "",
            partner_status_by_type: formBusinessPartner?.partner_status_by_type || { party_mode: resolvePartnerMode(formBusinessPartner), customer: '', client: '' },
        },
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            setDialogText(t('Common.Saving'));
            setVisible(true);

            const mode = values?.partner_status_by_type?.party_mode || 'none';
            const nonCustomerTypes = (Array.isArray(values.types) ? values.types : []).filter((x) => x !== 'customer');
            const normalizedTypes = mode === 'customer' ? [...nonCustomerTypes, 'customer'] : nonCustomerTypes;

            const payload = {
                ...values,
                types: normalizedTypes,
                partner_status_by_type: {
                    ...(values.partner_status_by_type || {}),
                    party_mode: mode,
                },
            };

            let formData = new FormData();
            for (let value in payload) {
                const current = payload[value];
                if (value === 'types') {
                    formData.append(value, JSON.stringify(current || []));
                    continue;
                }
                if (value === 'partner_status_by_type') {
                    formData.append(value, JSON.stringify(current || {}));
                    continue;
                }
                formData.append(value, current != null ? current : "");
            }
            if(formType==="add"){
                postRequest('/api/companies', formData,true)
                .then((response) => {
                    getRequest("/api/companies").then((response) => {
                        dispatch({type:'load_companies',newCompanies:response.data});
                        if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
                        if(response.data.length-1>=0)formik.setValues(response.data[response.data.length-1]);
                        setFormType("edit");
                        setVisible(false);
                        toast?.current?.show({ severity: 'info', summary: t('BusinessPartnerList.Toast.DeletedSummary'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                    });
                }).catch((reason) => {
                    setVisible(false);
                    alert(t('Common.Toast.ActionFailedDetail'));
                })
            }
            else{
                postRequest(`/api/companies/update/${formik.values.id}`, formData,true)
                .then((response) => {
                    getRequest("/api/companies").then((response) => {
                        dispatch({type:'load_companies',newCompanies:response.data});
                        if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
                        formik.setValues(values);
                        setVisible(false);
                        toast?.current?.show({ severity: 'info', summary: t('BusinessPartnerList.Toast.DeletedSummary'), life: 3000, detail: t('Common.Toast.RecordUpdatedDetail') });
                    });
                }).catch((reason) => {
                    setVisible(false);
                    alert(t('Common.Toast.ActionFailedDetail'));
                })
            }
      },
    });

    const onTypesChange = (e) => {
        let _types = [...formik.values.types];
        if (e.value === 'customer') return;
        if (e.checked)
            _types.push(e.value);
        else
            _types.splice(_types.indexOf(e.value), 1);
            formik.setFieldValue('types',_types);
    }

    const selectedPartyMode = formik.values?.partner_status_by_type?.party_mode || 'none';

    const onPartyTypeCheckboxChange = (mode, checked) => {
        const nextMode = checked ? mode : 'none';
        formik.setFieldValue('partner_status_by_type', {
            ...(formik.values.partner_status_by_type || {}),
            party_mode: nextMode,
        });
    };

    return (
        <>
        <div className='w-full h-10 flex flex-row bg-[#333]'>
      <IntersectionObserverWrapper>
      <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="saveandclose"><button className="disabled:opacity-25" disabled={insertCopyIcon} type='submit' onClick={() => {setCloseTab(true);submitRef.current.click();}}><SaveAndCloseIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="save"><button className="disabled:opacity-25" disabled={insertCopyIcon} type='submit' onClick={() => submitRef.current.click()}><SaveIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="add"><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => addNewErrorType()}><AddIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="copy"><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => copyErrorType()}><CopyIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="vert"><VerticalLineIcon/></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="favorite"><button onClick={() => openFavoriteDialog(t('BusinessPartnerList.Tab.New'),"BusinessPartnerAdd")}><FavoriteIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="fast"><button onClick={() => setFastView("BusinessPartnerAdd",null,null)}><PriceIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="vert"><VerticalLineIcon/></div>
        </IntersectionObserverWrapper>
      </div>
        <form onSubmit={formik.handleSubmit}>
        <div className="relative flex flex-col overflow-x min-h-[calc(100vh-177px)]">
          <div className='xl:grid grid-cols-2 gap-1 mb-2 '>
            <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                <h1 className="text-3xl font-semibold text-left text-zinc-900">
                   {t('BusinessPartnerAdd.Title')}
                </h1>
                {formType=="edit" && <label className="block text-md font-semibold text-gray-800">{t('Common.RecordIdLabel')}: {formik.values.id}</label>}
                        <div>
                        <label
                            for="name"
                            className="block text-md font-semibold text-gray-800"
                        >
                            {t('BusinessPartnerAdd.Label.Name')}
                        </label>
                        <input
                            name='name'
                            type="text"
                            required
                            onChange={formik.handleChange} value={formik.values.name}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        <button type="submit" ref={submitRef} className='hidden'></button>          
                        </div>
                        <div className='grid grid-cols-2 gap-4 mt-4'>
                          <div>
                            <label
                              htmlFor="defined_id"
                              className="block text-md font-semibold text-gray-800"
                            >
                              {t('BusinessPartnerAdd.Label.DefinedId')}
                            </label>
                            <input
                              name='defined_id'
                              type="text"
                              onChange={formik.handleChange} value={formik.values.defined_id}
                              className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                            />
                            <p className="text-xs text-gray-500 mt-1">{t('BusinessPartnerAdd.DefinedIdHint')}</p>
                          </div>
                          <div>
                            <label
                              htmlFor="type"
                              className="block text-md font-semibold text-gray-800"
                            >
                              {t('BusinessPartnerList.Column.PartnerType')}
                            </label>
                            <div className='grid grid-cols-2 py-2'>
                              <div className="flex align-items-center">
                                <Checkbox name="types" value={"supplier"} onChange={onTypesChange} checked={formik.values.types?.includes("supplier")} className='p-button-sm p-button-text'/>
                                <label htmlFor={"supplier"} className="ml-2">{t('BusinessPartnerAdd.Type.Supplier')}</label>
                              </div>
                              <div className="flex align-items-center">
                                <Checkbox name="types" value={"calibration_company"} onChange={onTypesChange} checked={formik.values.types?.includes("calibration_company")} className='p-button-sm p-button-text'/>
                                <label htmlFor={"calibration_company"} className="ml-2">{t('BusinessPartnerAdd.Type.CalibrationCompany')}</label>
                              </div>
                              <div className="flex align-items-center">
                                <Checkbox name="types" value={"training_company"} onChange={onTypesChange} checked={formik.values.types?.includes("training_company")} className='p-button-sm p-button-text'/>
                                <label htmlFor={"training_company"} className="ml-2">{t('BusinessPartnerAdd.Type.TrainingCompany')}</label>
                              </div>
                              <div className="flex align-items-center">
                                <Checkbox name="types" value={"service_company"} onChange={onTypesChange} checked={formik.values.types?.includes("service_company")} className='p-button-sm p-button-text'/>
                                <label htmlFor={"service_company"} className="ml-2">{t('BusinessPartnerAdd.Type.ServiceCompany')}</label>
                              </div>
                              <div className="flex align-items-center">
                                <Checkbox
                                  name="party_mode_customer"
                                  onChange={(e) => onPartyTypeCheckboxChange('customer', e.checked)}
                                  checked={selectedPartyMode === 'customer'}
                                  className='p-button-sm p-button-text'
                                />
                                <label htmlFor={"party_mode_customer"} className="ml-2">{t('BusinessPartnerAdd.Type.Customer')}</label>
                              </div>
                              <div className="flex align-items-center">
                                <Checkbox
                                  name="party_mode_client"
                                  onChange={(e) => onPartyTypeCheckboxChange('client', e.checked)}
                                  checked={selectedPartyMode === 'client'}
                                  className='p-button-sm p-button-text'
                                />
                                <label htmlFor={"party_mode_client"} className="ml-2">{t('BusinessPartnerAdd.Type.Client')}</label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mt-2 p-3 bg-white border rounded-md">
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
                                <div>
                                    <div>
                                        <label className="block text-sm text-gray-700">{t('BusinessPartnerAdd.ReadOnly.CustomerState')}</label>
                                        <div className="mt-1 p-2 bg-white border rounded-md grid grid-cols-1 gap-1">
                                          <div className="flex align-items-center">
                                            <Checkbox inputId="bp_state_occupied" checked={String(customerState) === String(t('BusinessPartnerAdd.ReadOnly.CustomerState.Occupied'))} onChange={() => {}} className='p-button-sm p-button-text' />
                                            <label htmlFor="bp_state_occupied" className="ml-2">{t('BusinessPartnerAdd.ReadOnly.CustomerState.Occupied')}</label>
                                          </div>
                                          <div className="flex align-items-center">
                                            <Checkbox inputId="bp_state_free" checked={String(customerState) === String(t('BusinessPartnerAdd.ReadOnly.CustomerState.Free'))} onChange={() => {}} className='p-button-sm p-button-text' />
                                            <label htmlFor="bp_state_free" className="ml-2">{t('BusinessPartnerAdd.ReadOnly.CustomerState.Free')}</label>
                                          </div>
                                        </div>
                                    </div>
                                    <div className="mt-3">
                                        <label className="block text-sm text-gray-700">{t('BusinessPartnerAdd.ReadOnly.Trader')}</label>
                                        <input type="text" disabled value={traderName} className="block w-full px-3 py-2 mt-1 bg-gray-100 border rounded-md" />
                                    </div>
                                </div>
                                <div>
                                    <label className="block text-sm text-gray-700">{t('CustomerCentralDatabaseList.Col.CustomerType')}</label>
                                    <div className="mt-1 p-2 bg-white border rounded-md grid grid-cols-1 gap-1">
                                      {customerTypeOptions.map((opt) => (
                                        <div key={`bp-customer-type-${opt.value}`} className="flex align-items-center">
                                          <Checkbox
                                            inputId={`bp_customer_type_${opt.value}`}
                                            checked={formik.values?.partner_status_by_type?.customer === opt.value}
                                            onChange={() => {}}
                                            className='p-button-sm p-button-text pointer-events-none'
                                          />
                                          <label htmlFor={`bp_customer_type_${opt.value}`} className="ml-2">{opt.label}</label>
                                        </div>
                                      ))}
                                    </div>
                                </div>
                                <div>
                                    <label className="block text-sm text-gray-700">Typ klienta</label>
                                    <div className="mt-1 p-2 bg-white border rounded-md grid grid-cols-1 gap-1">
                                      {clientTypeOptions.map((opt) => (
                                        <div key={`bp-client-type-${opt.value}`} className="flex align-items-center">
                                          <Checkbox
                                            inputId={`bp_client_type_${opt.value}`}
                                            checked={formik.values?.partner_status_by_type?.client === opt.value}
                                            onChange={() => {}}
                                            className='p-button-sm p-button-text pointer-events-none'
                                          />
                                          <label htmlFor={`bp_client_type_${opt.value}`} className="ml-2">{opt.label}</label>
                                        </div>
                                      ))}
                                    </div>
                                </div>
                            </div>
                        </div>
            </div>
            <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                        <div>
                        <label
                            htmlFor="contact_person"
                            className="block text-md font-semibold text-gray-800 mt-2"
                        >
                            {t('BusinessPartnerAdd.Label.ContactPerson')}
                        </label>
                        <input
                            name='contact_person'
                            type="text"
                            onChange={formik.handleChange} value={formik.values.contact_person}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div> 
                        <div>
                        <label
                            htmlFor="country"
                            className="block text-md font-semibold text-gray-800"
                        >
                            {t('BusinessPartnerAdd.Label.Country')}
                        </label>
                        <Select className="block w-full h-10"
                         showSearch={true} optionFilterProp="data-label" value={formik.values.country} onChange={(e) => formik.setFieldValue("country",e)}>
                            <Select.Option value="">{t('BusinessPartnerAdd.SelectCountry')}</Select.Option>
                            {countryOptions.map((country) => (
                            <Select.Option key={country.value} value={country.value} data-label={country.label}>{country.label}</Select.Option>
                            ))}
                        </Select>
                        </div> 
                        <div>
                        <label
                            htmlFor="address"
                            className="block text-md font-semibold text-gray-800"
                        >
                            {t('BusinessPartnerAdd.Label.Address')}
                        </label>
                        <input
                            name='address'
                            type="text"
                            onChange={formik.handleChange} value={formik.values.address}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="tel_number"
                            className="block text-md font-semibold text-gray-800"
                        >
                            {t('BusinessPartnerAdd.Label.Phone')}
                        </label>
                        <input
                            name='tel_number'
                            type="text"
                            onChange={formik.handleChange} value={formik.values.tel_number}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="email"
                            className="block text-md font-semibold text-gray-800"
                        >
                            {t('BusinessPartnerAdd.Label.Email')}
                        </label>
                        <input
                            name='email'
                            type="text"
                            onChange={formik.handleChange} value={formik.values.email}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="web_address"
                            className="block text-md font-semibold text-gray-800"
                        >
                            {t('BusinessPartnerAdd.Label.WebAddress')}
                        </label>
                        <input
                            name='web_address'
                            type="text"
                            onChange={formik.handleChange} value={formik.values.web_address}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="description"
                            className="block text-md font-semibold text-gray-800"
                        >
                            {t('BusinessPartnerAdd.Label.Note')}
                        </label>
                        <textarea
                            name='description'
                            type="text"
                            onChange={formik.handleChange} value={formik.values.description}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        >
                        </textarea>
                        </div>
            </div>
            </div>
            </div>
            </form>
            </>
            );
} 
